export const SETTLEMENT_MODES = ['PREPAID_CREDIT', 'POSTPAID_PERIODIC', 'PREPAID_PERIOD'];
export const SETTLEMENT_PERIOD_PLAN_KINDS = ['DAYS', 'WEEKDAY', 'MONTH_DAY'];
export const SETTLEMENT_PAYMENT_METHOD_CODES = ['CASH', 'BANK_TRANSFER', 'INSTANT_PAYMENT', 'OTHER'];
export const SETTLEMENT_REPORT_FILTERS = ['overdue', 'below_negative_tolerance', 'above_positive_tolerance', 'in_debt'];
export class DriverSettlementApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** `GET /v1/driver/settlement`. */
    settlement() {
        return this.client.request({ method: 'GET', path: '/v1/driver/settlement', auth: true });
    }
    /** `POST /v1/driver/settlement/period-purchases` — pays the plan from the wallet (`INSUFFICIENT_WALLET_BALANCE` otherwise). */
    buyPeriod(planId) {
        return this.client.request({ method: 'POST', path: '/v1/driver/settlement/period-purchases', body: { planId }, auth: true });
    }
}
const m = (market) => `market=${encodeURIComponent(market)}`;
export class SettlementAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** `GET /v1/admin/settlement/report` — local days [from, to] (default: the last 7 days). */
    report(market, opts = {}) {
        const q = [m(market), ...(opts.from !== undefined ? [`from=${opts.from}`] : []), ...(opts.to !== undefined ? [`to=${opts.to}`] : []), ...(opts.filter !== undefined ? [`filter=${opts.filter}`] : [])].join('&');
        return this.client.request({ method: 'GET', path: `/v1/admin/settlement/report?${q}`, auth: true });
    }
    /** The path of the CSV export (UTF-8 with BOM) — the Admin fetches it with the session and offers it as a file. */
    reportCsvPath(market, opts = {}) {
        const q = [m(market), 'format=csv', ...(opts.from !== undefined ? [`from=${opts.from}`] : []), ...(opts.to !== undefined ? [`to=${opts.to}`] : []), ...(opts.filter !== undefined ? [`filter=${opts.filter}`] : [])].join('&');
        return `/v1/admin/settlement/report?${q}`;
    }
    delinquents(market) {
        return this.client.request({ method: 'GET', path: `/v1/admin/settlement/delinquents?${m(market)}`, auth: true });
    }
    driver(market, driverId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/settlement/drivers/${encodeURIComponent(driverId)}?${m(market)}`, auth: true });
    }
    plans(market) {
        return this.client.request({ method: 'GET', path: `/v1/admin/settlement/plans?${m(market)}`, auth: true });
    }
    /** Create (no `planId`) or revise (`planId` + `expectedVersion`) a plan of the market. */
    savePlan(input) {
        return this.client.request({ method: 'POST', path: '/v1/admin/settlement/plans', body: input, auth: true });
    }
    changes(market, status = 'PENDING') {
        return this.client.request({ method: 'GET', path: `/v1/admin/settlement/changes?${m(market)}&status=${status}`, auth: true });
    }
    /** D838: a driver (`driverId`) or a driver group (`groupId`, ASSIGN_MODE / CLEAR_MODE only) - exactly one. */
    proposeChange(input) {
        return this.client.request({ method: 'POST', path: '/v1/admin/settlement/changes', body: input, auth: true });
    }
    decideChange(changeId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/settlement/changes/${encodeURIComponent(changeId)}/decision`, body: input, auth: true });
    }
    /** Propose settlement payments (TOTAL or PERIOD, by a method); another operator applies each in the wallet inbox. */
    proposePayments(input) {
        return this.client.request({ method: 'POST', path: '/v1/admin/settlement/payments', body: input, auth: true });
    }
}
//# sourceMappingURL=driver-settlement.js.map